module.exports = __webpack_public_path__ + "static/media/admin-signin-right-shape.70fc2f2f.png";